import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { TextInput } from '../../../../Helpers/Inputs';
import InputMaxValue from '../../../../Helpers/Formatters/InputMaxValue';

export default function SavingDetails(props) {
    return (
        <React.Fragment>
            <Row>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="totalSaving"
                            id="totalSaving"
                            value={props.state.totalSaving}
                            onChange={e => props.onFieldChange('totalSaving', e.target.value)}
                            label="Total Savings (Willing to use towards debt)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps : { max: 1000000 }
                            }}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <TextInput
                            name="existingInsurance"
                            id="existingInsurance"
                            value={props.state.existingInsurance}
                            onChange={e => props.onFieldChange('existingInsurance', e.target.value)}
                            label="Existing Life Insurance (Sum of all policies)"
                            InputProps={{
                                inputComponent: InputMaxValue,
                                inputProps : { max: 5000000 }
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/CoverageAmountPopUp/SavingDetails.js